import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
import FirebaseConnector from "../lib/FirebaseConnector";
const apiConnector = new APIConnector({ timeout: 60000 })
const firebaseConnector = new FirebaseConnector({ timeout: 30000 });

export default class StatsConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointStats() {
    return `${StatsConfig.endpoint}/stats`;
  }
  static get endpointStatsByClient() {
    return `${StatsConfig.endpointStats}/byClient`;
  }
  static get endpointStatsByClientExport() {
    return `${StatsConfig.endpointStatsByClient}/export`;
  }
  static get endpointStatsByClientDetail() {
    return `${StatsConfig.endpointStats}/byClientDetail`;
  }

  static get endpointStatsByEvent() {
    return `${StatsConfig.endpointStats}/byEvent`;
  }
  static get endpointStatsByEventExport() {
    return `${StatsConfig.endpointStatsByEvent}/export`;
  }
  static get endpointStatsByRRPP() {
    return `${StatsConfig.endpointStats}/byRRPP`;
  }
  static get endpointStatsByRRPPExport() {
    return `${StatsConfig.endpointStatsByRRPP}/export`;
  }
  static get endpointStatsByRRPPDetail() {
    return `${StatsConfig.endpointStats}/byRrppDetail`;
  }
  
  static get APIConnector() {
    return apiConnector
  }
  static get FirebaseConnector() {
    return firebaseConnector;
  }
}



// WEBPACK FOOTER //
// ./src/provider/stats/StatsConfig.js